'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

var _messages = require('common/messages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

module.exports = {

    /**
    * isNew is either explicitly set by you, or set via the existence of the data property, which is always set when when we have retrieved from the backend.
    */

    initialize: function initialize() {

        if (!this.notifier && !process.env.NODE_ENV === 'test') {
            console.error('notifier does not exist for model apiEndpoints: %s, data: ', this.apiEndpoints, this.data);
        }

        if (!this.isNew) {
            this.isNew = function () {
                return !this.data;
            };
        }
    },


    /**
    */

    toJSON: function toJSON() {
        return this.toData();
    },


    /**
    */

    save: function save() {
        var method = this.isNew() ? this.insert : this.update;
        return method.apply(this, arguments);
    },


    /**
    */

    insert: function insert() {
        return this._run.apply(this, [_messages.INSERT].concat(Array.prototype.slice.call(arguments)));
    },


    /**
    */

    update: function update() {
        return this._run.apply(this, [_messages.UPDATE].concat(Array.prototype.slice.call(arguments)));
    },


    /**
    */

    load: function load() {
        return this._run.apply(this, [_messages.LOAD].concat(Array.prototype.slice.call(arguments)));
    },


    /**
    */

    remove: function remove() {
        return this._run.apply(this, [_messages.REMOVE].concat(Array.prototype.slice.call(arguments)));
    },


    /**
    */

    fetch: function fetch(operationName, options, onRun) {
        var _this = this;

        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var _ref, _ref2, data;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            if (typeof options === 'function') {
                                onRun = options;
                                options = {};
                            }
                            // KEEP THIS HERE. If notifier does not exist, throw a very descriptive & debuggable message. (CC)

                            if (_this.notifier) {
                                _context.next = 3;
                                break;
                            }

                            throw new Error('notifier does not exist for model with apiEndpointAlias: ' + _this.apiEndpointAlias);

                        case 3:
                            _context.prev = 3;
                            _context.next = 6;
                            return _this.notifier.notify(_messages.RequestMessage.create(operationName, _this.apiEndpointAlias, _extends({ target: _this }, options)));

                        case 6:
                            _ref = _context.sent;
                            _ref2 = _slicedToArray(_ref, 1);
                            data = _ref2[0];


                            if (onRun) onRun(void 0, _this);
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](3);

                            if (onRun) onRun(_context.t0);
                            throw _context.t0;

                        case 16:
                            return _context.abrupt('return', data || {});

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[3, 12]]);
        }))();
    },


    /**
    */

    _run: function _run(operationName, options, onRun) {

        if (typeof options === 'function') {
            onRun = options;
            options = {};
        }

        if (!onRun) {
            onRun = function onRun() {};
        }

        var beforeOnRun = function (error, data) {

            var props = {
                loading: false
            };

            if (error) {
                props.error = error;

                // check if there's any data at all
            } else if (!!Object.keys(data).length) {
                props.data = (0, _extend2['default'])({}, data);
            }

            this.setProperties(props);
            onRun.apply(this, arguments);
        }.bind(this);

        this.setProperties({
            'error': void 0,
            'loading': true
        });

        var ret = this.fetch(operationName, options);
        ret.then(beforeOnRun.bind(this, void 0), beforeOnRun);
        return ret;
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/models/mixins/model.js
 ** module id = 496
 ** module chunks = 0 1
 **/